import DOMPurify from 'dompurify';

export const resume_demo_datas = {
  first_name: {
    value: 'TOM'
  },
  last_name: {
    value: 'PETER'
  },
  full_name: {
    value: 'TOM PETER'
  },
  mobile_number: {
    value: '(123) 456-7890'
  },
  email: {
    value: 'tom.peter@gmail.com'
  },
  profile_image: {
    value: 'https://www.corporatephotographerslondon.com/wp-content/uploads/2021/06/non-smiling-LinkedIn-profile-photo.jpg'
  },
  skills: {
    value: [
      {
        label: 'HTML5',
        value: 'HTML5'
      },
      {
        label: 'CSS3',
        value: 'CSS3'
      },
      {
        label: 'JavaScript',
        value: 'JavaScript'
      },
      {
        label: 'React',
        value: 'React'
      },
      {
        label: 'Angular',
        value: 'Angular'
      }
    ]
  },
  location: {
    value: '123 Elm Street, Springfield, IL 62701'
  },
  qualifications: {
    value: [
      {
        qualification: 'BCA',
        college: 'Bangalore',
        course_start_date: '01/05/2015',
        course_completed_date: '30/04/2018',
      },
      {
        qualification: 'MCA',
        college: 'Bangalore',
        course_start_date: '01/05/2019',
        course_completed_date: '30/04/2021',
      },
    ]
  },
  languages: {
    value: [
      {
        label: 'English',
        value: 'English'
      },
      {
        label: 'Malayalam',
        value: 'Malayalam'
      }
    ]
  },
  projects: {
    value: [
      {
        project_name: 'E-commerce Website',
        responsibility:
          'Developed a responsive e-commerce website using React and integrated payment gateway.',
      },
      {
        project_name: 'Portfolio Website',
        responsibility:
          'Designed and built a portfolio website showcasing personal projects and skills.',
      },
    ]
  },
  experiences: {
    value: [
      {
        company: 'XYZ Corporation',
        designation: 'React js developer',
        worked_from: '01/05/2018',
        worked_till: '05/12/2019',
        location: 'Kochi,Kerala',
        responsibilities:
          'Assisted in developing front-end features for company projects. Participated in code reviews and provided constructive feedback.',
      },
    ]
  },
  designation: {
    value: 'React JS developer'
  },
  about_me:
    {
      value: 'Proficient in numerous programming languages including JavaScript, HTML, and CSS. Proven ability to design and optimize web applications for seamless performance and high usability. Committed to producing high-quality, user-friendly, scalable web applications'
    },
  total_exp: {
    value: '5years'
  },
};

export const htmlContent = (resumeData) => {
  return `<!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Resume</title>
  </head>
  <body style="background-color: #f4f4f4; margin: 0px; padding: 20px; line-height: 1.6;">
      <div class="container" style="font-family: Arial, sans-serif;line-height: 1.6;background-color: #fff;margin: auto;padding: 20px;max-width: 800px;border-radius: 8px;box-shadow: 0 0 10px rgba(0,0,0,0.1);">
          <div class="profile" style="text-align: center;border-bottom: 2px solid rgb(212, 208, 208); padding: 10px; margin-bottom: 20px;">
              <h2 class="full_name" style="margin-bottom: 5px;font-weight: 600;">${resumeData?.first_name} ${resumeData?.last_name}</h2>
              <p class="designation" style="margin: 5px 0;">${resumeData?.designation}</p>
              <p class="mobile_number" style="margin: 5px 0;">${resumeData?.mobile_number}</p>
              <p class="address" style="margin: 5px 0;">${resumeData?.address}</p>
          </div>
  
          <div class="section" style="margin-bottom: 30px;">
              <h3 class="" style="padding-bottom: 5px; margin-bottom: 10px; font-weight: 600;">Employment History</h3>
              ${resumeData.experiences
                .map(
                  (exp) => `
                    <div class="item experiences">
                      <h4 class="designation">${exp?.designation}</h4>
                      <p><span class="company">${exp?.company}</span> | <span class="start_date">${exp?.start_date}</span> - <span class="end_date">${exp?.end_date}</span></p>
                      <ul class="description">
                          <li>${exp?.description}</li>
                      </ul>
                  </div>
                `,
                )
                .join('')}
              
          </div>
  
          <div class="section skills" style="margin-bottom: 30px;">
              <h3 style="padding-bottom: 5px;margin-bottom: 10px;font-weight: 600;">Skills</h3>
              ${resumeData?.skills
                .map(
                  (
                    skill,
                  ) => ` <ul class="skills" style="list-style-type: none;padding: 0;">
                      <li style="margin-bottom: 5px;">${skill}</li>
                  </ul>`,
                )
                .join('')}
             
          </div>
  
          <div class="section" style="margin-bottom: 30px;">
              <h3 style="padding-bottom: 5px; margin-bottom: 10px;font-weight: 600;">Educational Background</h3>
              ${resumeData?.qualifications
                .map(
                  (qualif) => `
                    <div class="item" style="margin-bottom: 10px;">
                      <h4> ${qualif?.course}</h4>
                      <p>${qualif?.university} | ${qualif?.year}</p>
                  </div>`,
                )
                .join('')}
              
          </div>
  
          <div class="section projects" style="margin-bottom: 30px;">
              <h3 style="padding-bottom: 5px; margin-bottom: 10px;font-weight: 600;">Projects</h3>
              ${resumeData?.projects
                .map(
                  (pro) => `
                    <div class="project" style="margin-bottom: 10px;">
                      <h4>${pro?.project}</h4>
                      <p>${pro?.description}</p>
                  </div>`,
                )
                .join('')}
          </div>
      </div>
  </body>
  </html>
        `;
};

export const apiResponseData =
  "<!DOCTYPE html> <html lang='en'> <head> <meta charset='UTF-8' /> <meta name='viewport' content='width=device-width, initial-scale=1.0' /> <title>Resume</title> </head> <body> <div class='container' id='resume' style='height: 100%; background-color: #fff;padding: 20px;border-radius: 8px;box-shadow: 0 0 0 rgba(0, 0, 0, 0.1);margin: auto;'> <div class='main_head' style='padding: 10px; letter-spacing: 4px; border-bottom: 1px solid rgb(216, 214, 214);opacity: 0.7;padding-bottom: 25px;'> <h1 style='font-size: 30px;font-weight: 700'>${resumeData?.first_name}</h1> <h1 style='font-size: 30px;font-weight: 700'>${resumeData?.last_name}</h1> <p style='font-size: 14px;'>${resumeData?.designation}</p> </div> <div class='main_container' style='display: flex;opacity: 0.8;'> <div style=' width: 36%; border-right: 1px solid rgb(216, 214, 214); padding: 10px; ' > <div> <h2 class='custom-underline' style='margin-bottom: 20px; font-size: 23px;position: relative;display: inline-block;font-weight: 600' > DETAILS <span style=' position: absolute; bottom: 0; left: 0; width: 25%; height: 2px; background-color: #000'></span> </h2> <div style='margin-bottom: 10px'> <p style='font-weight: 600'>ADDRESS</p> <p>${resumeData?.address}</p> </div> <div style='margin-bottom: 10px'> <p style='font-weight: 600'>PHONE</p> <p>${resumeData?.mobile_number}</p> </div> <div style='margin-bottom: 10px'> <p style='font-weight: 600'>EMAIL</p> <p>${resumeData?.email}</p> </div> </div> <div style='margin-bottom: 20px'> <h2 class='custom-underline' style='margin-bottom: 20px; font-size: 23px;position: relative;display: inline-block; font-weight: 600' > SKILLS <span style=' position: absolute; bottom: 0; left: 0; width: 25%; height: 2px; background-color: #000'></span> </h2> ${resumeData?.skills.map(skill => `<div style='display: flex; flex-direction: column'> <label for='file'>${skill}:</label> <progress id='file' value='88' max='100'>88%</progress> </div>`).join('')} </div> <div> <h2 class='custom-underline' style='margin-bottom: 20px; font-size: 23px;position: relative;display: inline-block;font-weight: 600' > LANGUAGES <span style=' position: absolute; bottom: 0; left: 0; width: 25%; height: 2px; background-color: #000'></span> </h2> ${resumeData?.languages.map(language => `<div style='display: flex; flex-direction: column'> <label for='file'>${language}:</label> <progress id='file' value='88' max='100'>88%</progress> </div>`).join('')} </div> </div> <div style='padding: 10px; width: 78%'> <div style='margin-bottom: 20px'> <h2 class='custom-underline' style='margin-bottom: 20px; font-size: 23px;position: relative;display: inline-block;font-weight: 600' > PROFILE <span style=' position: absolute; bottom: 0; left: 0; width: 25%; height: 2px; background-color: #000'></span> </h2> <p style='text-align: justify;text-wrap'> ${resumeData?.about_me} </p> </div> <div> <h2 class='custom-underline' style='margin-bottom: 20px; font-size: 23px;position: relative;display: inline-block;font-weight: 600' > EMPLOYMENT HISTORY <span style=' position: absolute; bottom: 0; left: 0; width: 25%; height: 2px; background-color: #000'></span> </h2> ${resumeData.experiences.map(exp => ` <div> <div style=' display: flex; justify-content: space-between; align-items: center; ' > <p style='font-weight: 600'> ${exp?.designation},<span>${exp?.company}</span> </p> <span>${exp?.location}</span> </div> <p>${exp?.start_date}-${exp?.end_date}</p> <div> <ul> <li>${exp?.description}</li> </ul> </div> </div> `).join('')} <div> <h2 class='custom-underline' style='margin-bottom: 20px; font-size: 23px;position: relative;display: inline-block;font-weight: 600' > EDUCATION <span style=' position: absolute; bottom: 0; left: 0; width: 25%; height: 2px; background-color: #000'></span> </h2> ${resumeData?.qualifications.map(qualif => ` <div> <div style=' display: flex; justify-content: space-between; align-items: center; ' > <p style='font-weight: 600'> ${qualif?.course} </p> <span>${qualif?.university}</span> </div> <p>${qualif?.year}</p> </div>`).join('')} </div> </div> </div> </div> </body> </html>";

export const apiResponseData1 =
  "<!DOCTYPE html> <html lang='en'> <head> <meta charset='UTF-8'> <meta name='viewport' content='width=device-width, initial-scale=1.0'> <title>Resume</title> </head> <body style='background-color: #f4f4f4; margin: 0px; padding: 20px; line-height: 1.6;'> <div class='container' style='font-family: Arial, sans-serif;line-height: 1.6;background-color: #fff;margin: auto;padding: 20px;max-width: 800px;border-radius: 8px;box-shadow: 0 0 10px rgba(0,0,0,0.1); height: 100%'> <div class='profile' style='text-align: center;border-bottom: 2px solid rgb(212, 208, 208); padding: 10px; margin-bottom: 20px;'> <h2 class='full_name' style='margin-bottom: 5px;font-weight: 600;'>${resumeData?.first_name} ${resumeData?.last_name}</h2> <p class='designation' style='margin: 5px 0;'>${resumeData?.designation}</p> <p class='mobile_number' style='margin: 5px 0;'>${resumeData?.mobile_number}</p> <p class='address' style='margin: 5px 0;'>${resumeData?.address}</p> </div> <div class='section' style='margin-bottom: 30px;'> <h3 class='' style='padding-bottom: 5px; margin-bottom: 10px; font-weight: 600;'>Employment History</h3> ${resumeData.experiences .map( (exp) => ` <div class='item experiences'> <h4 class='designation'>${exp?.designation}</h4> <p><span class='company'>${exp?.company}</span> | <span class='start_date'>${exp?.start_date}</span> - <span class='end_date'>${exp?.end_date}</span></p> <ul class='description'> <li>${exp?.description}</li> </ul> </div> `, ) .join('')} </div> <div class='section skills' style='margin-bottom: 30px;'> <h3 style='padding-bottom: 5px;margin-bottom: 10px;font-weight: 600;'>Skills</h3> ${resumeData?.skills .map( ( skill, ) => ` <ul class='skills' style='list-style-type: none;padding: 0;'> <li style='margin-bottom: 5px;'>${skill}</li> </ul>`, ) .join('')} </div> <div class='section' style='margin-bottom: 30px;'> <h3 style='padding-bottom: 5px; margin-bottom: 10px;font-weight: 600;'>Educational Background</h3> ${resumeData?.qualifications .map( (qualif) => ` <div class='item' style='margin-bottom: 10px;'> <h4> ${qualif?.course}</h4> <p>${qualif?.university} | ${qualif?.year}</p> </div>`, ) .join('')} </div> <div class='section projects' style='margin-bottom: 30px;'> <h3 style='padding-bottom: 5px; margin-bottom: 10px;font-weight: 600;'>Projects</h3> ${resumeData?.projects .map( (pro) => ` <div class='project' style='margin-bottom: 10px;'> <h4>${pro?.project}</h4> <p>${pro?.description}</p> </div>`, ) .join('')} </div> </div> </body> </html>";


export const apiResponseData2 = "<!DOCTYPE html><html lang='en'><head><meta charset='UTF-8'/><meta name='viewport' content='width=device-width, initial-scale=1.0'/><title>Resume</title></head><body style='line-height: 1.6;background-color: #f4f4f4;margin: 0px;padding: 20px;font-family: Arial, sans-serif;'><div class='container' style='height: 100%; background-color: #fff; padding: 10px;border-radius: 8px;box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);max-width: 800px;margin: auto;'><div class='main_head' style='padding: 30px;border-radius: 10px;background-color: rgb(233, 233, 233); display: flex; justify-content: space-between;align-items: center;'><h1 style='font-weight: bold;font-size: 2em;'>${resumeData?.first_name}</h1><div><p>${resumeData?.email} - ${resumeData?.mobile_number}</p><p>${resumeData?.address}</p></div></div><div style='padding: 30px;'><div><h3 style='margin-bottom: 10px;font-size: 1.17em;font-weight: bold'>${resumeData?.designation}</h3><p>${resumeData?.about_me}</p></div><div style='margin-top: 15px;'><h2 style='margin-bottom: 10px;font-weight: bold;font-size: 1.5em'>Career Experience</h2>${resumeData.experiences.map((exp) => `<div><div style='display: flex;justify-content: space-between; align-items: center;'><p>${exp?.designation} at <span>${exp?.company}</span><span>${exp?.location}</span></p><span>${exp?.start_date}-${exp?.end_date}</span></div><ul><li>${exp?.description}</li></ul></div>`,).join('')}</div><div style='margin-top: 15px;'><h2 style='margin-bottom: 10px;font-size: 1.5em;font-weight: bold'>Education</h2>${resumeData?.qualifications.map((qualif) => `<div><p> ${qualif?.course}, <span>${qualif?.year}</span></p><p>${qualif?.university}</p></div>`,).join('')}</div><div style='margin-top: 15px;'><h2 style='margin-bottom: 10px;font-size: 1.5em;font-weight: bold'>Skills</h2>${resumeData?.skills.map((skill,) => `<ul><li>${skill}</li></ul>`,).join('')}</div></div></div></body></html>"

export const generateResumeHTML = (apiResponseData, resumeData) => {
  console.log(resumeData, 'apiResponseDataapiResponseData');
  return eval('`' + apiResponseData + '`');
};

export const getSafeHtml = (resume_template,resume_data) => {
  const mySafeHTML = DOMPurify.sanitize(
    generateResumeHTML(resume_template, resume_data),
  );
  return mySafeHTML;
};



export function cleanHtmlString(htmlString) {
  let cleanedHtml = htmlString.replace(/\\/g, '');
  return cleanedHtml;
}


export function removeHtmlTags(str) {
  // Replace all HTML tags with a newline if it's a <li> tag, otherwise with an empty string
  return str.replace(/<\/?li>/g, '\n').replace(/<[^>]+>/g, '').trim().replace(/\n\s*\n/g, '\n');
}